import * as React from 'react';
import { Container } from 'types/Watchlist';
import { DateTime } from 'luxon';
import { DATE_FORMATS } from 'utils/container-transforms';
import { CellProps } from './types';
import { DualCell } from './DualCell';

export const DeletedOn: React.FC<CellProps> = (props) => {
  const container = props.row as Container;
  const formattedDate =
    container.deletedAt &&
    DateTime.fromISO(container.deletedAt).toFormat(DATE_FORMATS.SINGLE_DATE_TIME_FORMAT);
  return <DualCell topText={formattedDate} />;
};
DeletedOn.displayName = 'Shipments.Table.Cells.DeletedOn';
